import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { BillingServiceService } from 'src/app/epics/Account/Billings/shared/services/billing-service.service';

@Component({
    selector: 'app-billing-trial-modal',
    templateUrl: './billing-trial-modal.component.html',
    styleUrl: './billing-trial-modal.component.scss'
})
export class BillingTrialModalComponent {

    @Input() title: string = 'You have 3 days left in your free trail';
    @Input() subTitle: string = 'Your free trail ends in 3 days. Upgrade now to continue enjoying full access without interruption. ';

    @Input() is_showBack: boolean = true;

    @Output() handleLaterEvent: EventEmitter<void> = new EventEmitter();
    @Output() handleUpgradeEvent: EventEmitter<void> = new EventEmitter();
    constructor(
        private _billingService: BillingServiceService,
        private router: Router
    ) { }

    ngOnInit(): void {
    }

    handleLater(): void {
        this._billingService.set_is_Expire_Remaining_Notify(false);
        this._billingService.set_is_Expire_Notify(false);
        this.handleLaterEvent.emit();
    }

    handleUpgrade(): void {
        this._billingService.set_is_Expire_Remaining_Notify(false);
        this._billingService.set_is_Expire_Notify(false);
        this.handleUpgradeEvent.emit();

        this._billingService.setIsUpgradePlan(true);
        this.router.navigate(['/billings/main']);
    }
}
